import { gql } from '@apollo/client'

import WHERE_TO_START_FRAGMENT from '@/components/modals/components/WhereToStart/fragments/WhereToStartFragment'

import { REVIEW_PLAN_CHANGES_FRAGMENT } from '../../ReviewPlanChanges/fragments/reviewPlanChangesFragment'

const EDIT_DAILY_AMOUNT_DOG_FRAGMENT = gql`
  ${WHERE_TO_START_FRAGMENT}
  fragment EditDailyAmountDogFragment on Dog {
    id
    name
    ageInMonths
    dogProfile {
      id
      avatarUrl
    }
    roundedDailyCaloriesLowerBoundary: roundedPercentageOfDailyCalories(
      multipleOf: $caloriesMultipleOf
      percentage: $lowerPercentage
    )
    roundedDailyCaloriesUpperBoundary: roundedPercentageOfDailyCalories(
      multipleOf: $caloriesMultipleOf
      percentage: $upperPercentage
    )
    ...WhereToStartFragment
  }
`

const EDIT_DAILY_AMOUNT_PLAN_FRAGMENT = gql`
  ${REVIEW_PLAN_CHANGES_FRAGMENT}
  fragment EditDailyAmountPlanFragment on Plan {
    id
    pouchSize
    servingInformation {
      roundedCaloriesPerDay
      gramsPerDay
    }
    portioningForDogs {
      dogId
      portionInGrams
      roundedPortionInCalories(multipleOf: $caloriesMultipleOf)
    }
    ...ReviewPlanChangesFragment
  }
`

const EDIT_DAILY_AMOUNT_FRAGMENT = gql`
  ${EDIT_DAILY_AMOUNT_PLAN_FRAGMENT}
  ${EDIT_DAILY_AMOUNT_DOG_FRAGMENT}
  fragment EditDailyAmountFragment on User {
    id
    dogs {
      ...EditDailyAmountDogFragment
    }
    availablePlans(scopeType: $scopeType) {
      ...EditDailyAmountPlanFragment
    }
    subscription {
      id
      plan {
        ...EditDailyAmountPlanFragment
      }
    }
  }
`

export { EDIT_DAILY_AMOUNT_FRAGMENT }
